module.exports = __webpack_public_path__ + "static/media/second_single_layer.0e6375c4.png";